import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { hasRole, isAdmin, isOwner, ROLE_GROUPS } from '@/utils/constent';
export const useRoleCheck = () => {
  const user = useSelector((state: RootState) => state.user);
  const role = user.data?.role?.name;

  return {
    role,
    canAccessDWRequest: hasRole(role, ROLE_GROUPS.CAN_ACCESS_DW_REQUEST),
    canManageUsers: hasRole(role, ROLE_GROUPS.CAN_MANAGE_USERS),
    canViewReports: hasRole(role, ROLE_GROUPS.CAN_VIEW_REPORTS),
    isOwner: isOwner(role),
    isAdmin: isAdmin(role),
    checkRole: (allowedRoles: readonly string[]) => hasRole(role, allowedRoles),
  };
};
